import { render, staticRenderFns } from "./LastFlight.vue?vue&type=template&id=7ff45598&scoped=true&"
import script from "./LastFlight.vue?vue&type=script&lang=js&"
export * from "./LastFlight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff45598",
  null
  
)

export default component.exports